<div class="progress-spinner" *ngIf="isLoading">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="py-3">
  <div [ngClass]="conMessage === false ? 'reg-form' : 'reg-form-complete'">
    <div class="form-header-container row header m-responsiveStepper" *ngIf="!conMessage">
      <div class="m-try col-md-6  d-flex align-items-center">
        <div>
          <h2 class="create-account-heading">Create New Account</h2>
        </div>
        <div class="col-md-6 required-info-message-mobile">
          <span class="note">
            Please complete fields below to create your account.
          </span>
        </div>

        <div class="progressBarContainer progressBar-length">
          <ol class="ProgressBar">
            <li class="ProgressBar-step" [ngClass]="{ ProgressBarstep1: progressStep1 }">
              <span class="ProgressBar-icon" [ngClass]="{ dotActive: progressStep1 }">1</span>
            </li>

            <li class="ProgressBar-step" [ngClass]="{ ProgressBarstep1: progressStep2 }">
              <span class="ProgressBar-icon" [ngClass]="{ dotActive: progressStep2 }">
                2
              </span>
            </li>

            <li class="ProgressBar-step" [ngClass]="{ ProgressBarstep1: progressStep3 }">
              <span class="ProgressBar-icon" [ngClass]="{ dotActive: progressStep3 }">
                3
              </span>
            </li>

            <!-- <li class="ProgressBar-step" [ngClass]="{ ProgressBarstep1: progressStep4 }"
              *ngIf="userSelected != 'Provider'">
              <span class="ProgressBar-icon" [ngClass]="{ dotActive: progressStep4 }">
                4
              </span>
            </li> -->
          </ol>
        </div>


      </div>
      <div class="col-md-6 required-info-message">
        <span class="note">
          Please complete fields below to create your account.<br>For assistance, please reference the <a class="user-guide" (click)="open(content,'/assets/pdf/US-AP-2300177 IZERVAY My Way Portal Account Registration Guide.pdf', 1,'US-AP-2300177 IZERVAY My Way Portal Account Registration Guide')">User Registration Guide</a>.
        </span>
      </div>
    </div>

   <form #registrationForm0="ngForm" (ngSubmit)="onSubmit0(registrationForm0)" *ngIf="newReg0">
      <div class="reg0-container">
        <div class="mob-container">

          <div class="chooseAccountHolder chooseAccountHeading">
            <p>Tell us more about you.</p>
          </div>
          <div class="chooseAccountHolder chooseAccountSubHeading">
            <p>Which type of account would you like to create?</p>
          </div>
          <div class="chooseAccountHolder chooseAccountHeading m-accHolderRes">
            <div class="professional">
              <div [ngClass]="
                userSelected === 'Provider'
                  ? 'profession-container-selected'
                  : 'profession-container'
              " (click)="profileHandler('Provider')" (click)="SendChoosePrescriberEvent()">
                <div *ngIf="userSelected === 'Provider'" [ngClass]="userSelected === 'Provider' ? 'selectedUser' : ''">
                  <img class="professionalSelected" src="/assets/images/selected-viiv.svg" />
                </div>
                <svg width="58" height="65" viewBox="0 0 58 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.9516 63.9312C12.2384 63.8664 11.5252 63.8464 10.8121 63.8015C9.17469 63.7232 7.55085 63.4656 5.96958 63.0335C2.90748 62.1358 0.927645 60.2058 0.289293 57.049C0.159627 56.4156 0.0947555 55.7673 0 55.1289V52.8897C0.0797941 52.2713 0.144627 51.6479 0.249357 51.0295C0.979288 46.3676 3.4427 42.1534 7.1466 39.2299C8.33316 38.2732 9.63486 37.469 11.0215 36.8361L11.3357 36.7014C11.2609 36.856 11.216 36.9608 11.1661 37.0556C10.4531 38.449 10.0499 39.9801 9.98424 41.544C9.98574 41.6261 9.96698 41.7072 9.92958 41.7803C9.89217 41.8534 9.8373 41.9161 9.76983 41.9629C9.55492 42.1036 9.37287 42.289 9.23617 42.5065C9.03585 42.8287 8.75355 43.092 8.41822 43.2695C7.13044 44.187 6.10005 45.42 5.42594 46.8502C5.10022 47.3187 4.95343 47.8886 5.01209 48.4561C5.01335 48.5414 4.99269 48.6255 4.95219 48.7005C4.2071 50.6712 3.9421 52.7911 4.17916 54.8846C4.24756 55.4023 4.3939 55.9067 4.6131 56.3807C4.7661 56.7107 5.01676 56.9858 5.33121 57.1686C6.0271 57.6227 6.83459 57.8764 7.66516 57.9017C8.0342 57.9017 8.40823 57.9017 8.78227 57.9017C9.1333 57.9004 9.46979 57.7611 9.71894 57.5138C9.96809 57.2665 10.11 56.9311 10.1139 56.5801C10.1207 56.2293 9.98977 55.8899 9.74926 55.6344C9.50874 55.379 9.17776 55.2279 8.8272 55.2137C8.17818 55.2004 7.52896 55.222 6.88226 55.2785C6.61296 55.2785 6.55802 55.1488 6.54804 54.9643C6.50815 54.2761 6.45831 53.5829 6.4633 52.8946C6.49683 51.7859 6.71425 50.6905 7.10666 49.653C7.15944 49.5523 7.2266 49.46 7.3061 49.3787C7.51556 49.1194 7.75495 48.88 7.93947 48.6007C8.34343 47.9873 8.68759 47.339 9.1115 46.7405C9.35563 46.4183 9.6464 46.1343 9.97426 45.8977C10.2748 45.6155 10.6715 45.4583 11.0838 45.4583C11.4961 45.4583 11.893 45.6155 12.1935 45.8977C12.9684 46.5349 13.5976 47.3307 14.0387 48.2317C14.2575 48.5658 14.4975 48.8856 14.757 49.1892C14.813 49.2649 14.8598 49.3469 14.8965 49.4336C15.5433 51.1558 15.7707 53.0072 15.5598 54.8346C15.51 55.2984 15.505 55.2636 15.0611 55.2386C14.4651 55.1962 13.8667 55.1962 13.2707 55.2386C12.9269 55.2715 12.61 55.4387 12.3887 55.7039C12.1674 55.9691 12.0596 56.3108 12.0888 56.6549C12.1042 56.9945 12.2505 57.315 12.4968 57.5492C12.7431 57.7835 13.0704 57.9134 13.4103 57.9117C13.9195 57.9616 14.4323 57.9616 14.9414 57.9117C15.7324 57.7966 16.4763 57.4652 17.0909 56.9542C17.6092 56.4183 17.9035 55.7048 17.9137 54.9593C18.1384 52.821 17.8636 50.6597 17.1109 48.6456C17.0796 48.4948 17.0662 48.3408 17.0709 48.1868C17.0777 47.9022 17.0424 47.6183 16.9662 47.344C16.389 45.8658 15.42 44.5728 14.1634 43.6037C13.4741 43.0726 12.8211 42.4961 12.2085 41.8781C12.1803 41.8491 12.1582 41.8148 12.1436 41.7771C12.129 41.7394 12.1223 41.6991 12.1237 41.6587C12.2783 39.2998 13.1211 37.25 14.9564 35.699C15.1135 35.5752 15.2984 35.4914 15.495 35.4547C16.0486 35.3499 16.6071 35.2801 17.1657 35.1953C17.4449 36.7164 18.3975 37.8086 19.3451 38.8808C21.3864 41.102 23.6064 43.1519 25.9829 45.01C26.8656 45.7282 27.7684 46.4214 28.686 47.1395C29.3443 46.6408 29.9826 46.1421 30.6159 45.6434C33.0706 43.7495 35.3826 41.6775 37.5331 39.4444C38.1017 38.8359 38.6253 38.1926 39.129 37.5343C39.6855 36.8782 40.0542 36.0838 40.1962 35.2352C41.0989 35.2851 41.9268 35.3848 42.62 36.088C43.8982 37.4137 44.7764 39.0732 45.1535 40.8757C45.2632 41.3744 45.3131 41.8731 45.4029 42.3718C45.4477 42.6212 45.3779 42.7359 45.1186 42.8207C44.1724 43.1231 43.3495 43.7239 42.7733 44.533C42.197 45.3421 41.8984 46.316 41.9218 47.3091C41.9489 48.3294 42.3121 49.3123 42.9551 50.105C43.5981 50.8976 44.4848 51.4558 45.4776 51.6928C46.6306 51.9601 47.8422 51.775 48.8628 51.1756C49.8834 50.5763 50.6353 49.6082 50.9635 48.4711C51.2909 47.3323 51.1662 46.1111 50.6152 45.0621C50.0642 44.0131 49.1296 43.2173 48.0061 42.8406C47.8583 42.8118 47.7261 42.7301 47.6343 42.6107C47.5425 42.4913 47.4973 42.3425 47.5074 42.1923C47.3628 40.3716 46.8342 38.6022 45.9564 37.0007C45.9015 36.9009 45.8517 36.8012 45.8018 36.7014L45.8516 36.6316C46.5648 37.0007 47.2979 37.3299 47.9812 37.7438C50.2678 39.0644 52.2496 40.8534 53.7966 42.9934C55.3436 45.1335 56.421 47.5762 56.958 50.1617C57.1425 50.9696 57.1974 51.8025 57.3171 52.6254C57.3171 52.7301 57.357 52.8348 57.377 52.9346V55.1738C57.2922 55.7623 57.2273 56.3508 57.1176 56.9343C56.9231 58.2657 56.3661 59.518 55.5076 60.5542C54.6492 61.5903 53.5223 62.3704 52.2502 62.8091C50.6628 63.3715 49.004 63.7073 47.3228 63.8065C46.3603 63.8863 44.4353 63.996 44.4353 64.001L12.9516 63.9312Z"
                    fill="white" />
                  <path
                    d="M29.6041 0C30.2125 0.0847812 30.826 0.154606 31.4345 0.254349C34.5253 0.80687 37.3818 2.26666 39.6402 4.44787C41.8987 6.62908 43.457 9.433 44.1167 12.5027C44.6491 15.2753 44.5383 18.1331 43.7926 20.8562C42.7454 25.2566 40.6648 29.3442 37.7232 32.7804C36.3546 34.4177 34.655 35.7469 32.736 36.6804C29.4944 38.2064 26.3675 37.8772 23.3652 36.022C21.1377 34.5842 19.2435 32.6865 17.8096 30.4564C15.4187 26.942 13.8145 22.9529 13.1068 18.7616C12.5293 15.5933 12.926 12.3243 14.2446 9.38612C15.5632 6.44793 17.7418 3.9786 20.4927 2.30405C22.6011 1.01745 24.9863 0.253172 27.4498 0.0748191C27.5425 0.0637549 27.6342 0.0454194 27.7241 0.019968L29.6041 0ZM19.236 8.69259C18.9517 8.99681 18.7023 9.24113 18.4729 9.51043C16.7959 11.5387 15.6768 13.9693 15.2263 16.5622C15.0776 17.15 15.0237 17.7578 15.0667 18.3626C15.6486 22.1865 17.1006 25.8259 19.3107 29.0002C20.4977 30.8168 22.0335 32.3798 23.8291 33.5983C26.971 35.643 30.1477 35.7029 33.3445 33.718C34.4961 32.9852 35.5359 32.0899 36.4316 31.0599C38.8997 28.2185 40.6948 24.8568 41.6831 21.2252C42.1004 20.0608 42.2801 18.8246 42.2116 17.5896C42.1405 16.3836 41.7814 15.2121 41.1644 14.1734C40.8238 13.6108 40.3192 13.1658 39.7183 12.8984C39.1174 12.6309 38.4491 12.5538 37.8031 12.6773C35.8904 12.9912 33.9628 13.2059 32.0279 13.3206C29.7206 13.4826 27.402 13.3434 25.1307 12.9067C24.5679 12.7912 24.0133 12.6396 23.47 12.4528C21.5699 11.7995 19.989 10.7573 19.236 8.69259Z"
                    fill="white" />
                  <path
                    d="M48.6498 47.1285C48.6498 47.6946 48.4248 48.2375 48.0245 48.6378C47.6243 49.0381 47.0814 49.263 46.5153 49.263C45.9495 49.2577 45.4086 49.0296 45.01 48.6282C44.6113 48.2267 44.387 47.6843 44.3857 47.1185C44.3935 46.5592 44.6195 46.0252 45.0155 45.6302C45.4114 45.2351 45.946 45.0104 46.5053 45.004C46.7858 45.002 47.0638 45.0554 47.3236 45.1613C47.5834 45.2671 47.8197 45.4232 48.0189 45.6206C48.2182 45.818 48.3765 46.0529 48.4848 46.3116C48.593 46.5704 48.6491 46.848 48.6498 47.1285Z"
                    fill="white" />
                </svg>
              </div>
              <span>Prescriber</span>
            </div>
            <div class="professional">
              <div [ngClass]="
                userSelected === 'Other'
                  ? 'profession-container-selected'
                  : 'profession-container'
              " (click)="profileHandler('Other')" (click)="SendChooseHealthcareProfessionalEvent()">
                <div *ngIf="userSelected === 'Other'" [ngClass]="userSelected === 'Other' ? 'selectedUser' : ''">
                  <img class="professionalSelected" src="/assets/images/selected-viiv.svg" />
                </div>
                <svg width="54" height="63" viewBox="0 0 54 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M35.4491 57.5455L34.0278 57.7777C34.5016 52.8362 36.1977 50.581 39.0309 50.9221C42.0062 51.2775 43.0817 53.9875 42.1389 58.8911L40.7413 58.3746L40.2675 58.9668C40.7413 59.379 41.2388 60.1229 41.7126 60.1134C42.2574 60.1134 43.1955 59.4738 43.2523 59.0237C43.6835 55.7073 44.2946 52.3577 40.6039 50.1878C40.1017 49.8893 40.1537 48.5249 40.0779 47.6437C39.9974 46.6487 40.0779 45.6348 40.0779 44.0761C43.456 45.6964 46.4644 47.0183 49.3308 48.5959C50.1078 49.0271 50.7142 50.1641 50.9605 51.0879C51.7375 54.0348 52.3109 57.0386 53.031 60.3171C35.5331 63.6092 17.5778 63.643 0.0676507 60.4166C-0.505617 51.7844 2.50756 47.5821 11.2866 44.9858C10.7039 47.4399 12.4474 49.9414 9.69479 52.0592C8.27347 53.1347 8.79462 55.044 10.1686 56.2C11.5425 57.356 13.1865 57.2091 14.3899 55.8352C15.5933 54.4612 15.7307 52.6135 14.1767 51.666C11.2345 49.8751 12.4853 47.2551 12.4237 44.91C12.4237 44.4788 13.305 43.9387 13.8451 43.5834C17.0525 41.5509 20.0514 40.935 22.7662 44.5309C23.6853 45.7438 25.1351 46.535 26.4522 47.5868C28.4468 45.8149 30.3798 44.1945 32.1944 42.451C33.1419 41.5414 33.9473 41.4229 35.1223 41.9773C39.5852 44.1045 39.0167 42.8158 39.0451 47.6626C39.0451 49.0081 38.6851 49.714 37.2022 50.131C34.5538 50.8795 32.2038 55.3425 32.8813 58.0477C33.0055 58.3013 33.1902 58.5203 33.4191 58.6856C33.6479 58.8508 33.914 58.9572 34.1937 58.9953C34.7291 58.9953 35.2786 58.5215 35.8234 58.2373L35.4491 57.5455Z"
                    fill="#359DDC" />
                  <path
                    d="M47.554 37.7526C43.3706 38.7375 39.0324 38.8744 34.7952 38.1553C33.5975 37.968 32.3718 38.087 31.2324 38.5011C27.9667 39.7959 24.3239 39.7602 21.0842 38.4016C20.0915 38.0213 19.0147 37.9149 17.9667 38.0937C13.727 38.8593 9.37638 38.7626 5.1748 37.8094C5.70543 36.5823 6.12235 35.5163 6.59613 34.493C9.1782 28.8693 10.211 23.004 10.1542 16.7975C10.0784 7.82894 16.6165 0.689095 24.9549 0.0447604C33.445 -0.590098 41.5939 5.59742 42.1103 14.2154C42.622 22.3359 43.2379 30.2148 47.554 37.7526ZM29.8916 13.031C27.1532 14.5044 24.3248 16.1484 21.3637 17.565C19.3501 18.5126 16.2801 18.6073 15.323 20.1234C14.2476 21.8242 14.963 24.6905 15.0009 27.0499C15.1004 33.4696 19.9898 38.4205 26.1726 38.4205C32.4406 38.4205 37.311 33.6449 37.5194 27.2063C37.6324 24.9236 37.615 22.6362 37.4673 20.3555C37.2956 19.4279 36.8045 18.5898 36.0791 17.9866C34.0467 16.2242 31.8578 14.5944 29.8916 13.031V13.031Z"
                    fill="#359DDC" />
                  <path
                    d="M9.14941 53.9412C10.5234 52.9131 11.2815 51.9087 12.0632 51.8945C12.7312 51.8945 14.0294 53.06 13.9583 53.5906C13.8683 54.415 12.9492 55.6042 12.2054 55.7558C11.4615 55.9074 10.6134 54.8603 9.14941 53.9412Z"
                    fill="#359DDC" />
                </svg>
              </div>
              <div class="healthCareProfessionalContainer">
                <span class="healthCareProfessionalText">Other</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row selectionScreen">
          <div class="col-md-6 col-sm-6 next-btn-wrapper text-left m-responsiveBtn">
            <button type="button" class="btn btn-style btn-prev" (click)="backToLogin()">
              &lt; Back to Login</button>
          </div>
          <div class="col-md-6 col-sm-6 next-btn-wrapper m-responsiveBtn">
            <button type="submit" class="btn btn-style btn-next" [disabled]="userSelected === ''">
              Next >
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- RegistrationType Nurse/Others Wrapper -->
    <div *ngIf="userSelected != 'Provider'">
      <!-- First Registration Screen Form -->
      <form #registrationForm="ngForm" (ngSubmit)="onSubmit(registrationForm)" *ngIf="regNew">
        <div class="reg1-container">
          <div class="row">
            <div class="col-md-12 padding-0">
              <h2 class="sub-title">User Information</h2>
              <!-- <p class="note">
                Please enter your information for the new account profile.
              </p> -->
            </div>

            <div class="col-md-12 padding-0">
              <p class="required-text">
                <span>*</span>
                Required field
              </p>
            </div>

            <div class="col-md-3 col-6 custom-input-group padding-left-0">
              <label class="contact-last-name-style mt-0">
                First Name <span>*</span>
              </label>
              <input [ngClass]="{
                  'border-invalid': !contact.valid && contact.touched,
                  'border-valid': contact.valid
                }" type="text" class="form-control" id="firstName" name="firstName" [(ngModel)]="firstName" required
                #contact="ngModel" maxlength="50" (blur)="trimIt($event)" />
              <div *ngIf="!contact.valid && contact.touched" class="error-message">
                First Name Required
              </div>
            </div>

            <div class="col-md-3 col-6 custom-input-group padding-right-0">
              <label class="mt-0"> Last Name <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !secondname.valid && secondname.touched,
                  'border-valid': secondname.valid
                }" type="text" class="form-control" id="secondtName" name="secondtName" [(ngModel)]="secondtName"
                required #secondname="ngModel" maxlength="50" (blur)="trimIt($event)" />
              <div *ngIf="!secondname.valid && secondname.touched" class="error-message">
                Last Name Required
              </div>
            </div>

            <div class="col-md-3 col-6 custom-input-group padding-left-0">
              <label class="mt-0"> Phone <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !phone1.valid && phone1.touched,
                  'border-valid': phone1.valid
                }" type="text" class="form-control" id="phone" name="phone" appNumberformat [(ngModel)]="phone"
                [data]="providerPhone2.value" required #phone1="ngModel" #providerPhone2 maxlength="14"
                minlength="14" />
              <div *ngIf="phone == '' && phone1.touched" class="error-message">
                Phone Required
              </div>

              <div *ngIf="!phone1.valid && phone1.touched && phone != ''" class="error-message">
                Invalid Phone Number
              </div>
            </div>

            <div class="col-md-3 col-6 custom-input-group padding-right-0">
              <label class="mt-0"> Fax <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !fax1.valid && fax1.touched,
                  'border-valid': fax1.valid
                }" type="text" class="form-control" id="fax" name="fax" appNumberformat [(ngModel)]="fax"
                [data]="fax2.value" required #fax1="ngModel" #fax2 maxlength="14" minlength="14" />

              <div *ngIf="fax == '' && fax1.touched" class="error-message">
                Fax Required
              </div>
              <div *ngIf="!fax1.valid && fax1.touched && fax != ''" class="error-message">
                Invalid Fax
              </div>
            </div>

            <div class="col-md-6 custom-input-group padding-0">
              <label> Email <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !email1.valid && email1.touched,
                  'border-valid': email1.valid
                }" type="text" class="form-control" id="email" name="email" [(ngModel)]="email" required
                #email1="ngModel" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$" />

              <div *ngIf="email == '' && email1.touched" class="error-message">
                Email Required
              </div>

              <div *ngIf="!email1.valid && email1.touched && email != ''" class="error-message">
                Invalid Email
              </div>
            </div>

          </div>

          <div class="row user-detail-block">
            <div class="col-md-12 pb-3 padding-0">
              <p class="note font-weight-bold">
                Create a username and password to access your new online account.
              </p>
            </div>

            <div class="col-md-2 create-login">Create Login</div>

            <div class="username-width">
              <label> Username <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !userName1.valid && userName1.touched,
                  'border-valid': userName1.valid
                }" type="text" class="form-control" id="userName" name="userName" [(ngModel)]="userName" required
                #userName1="ngModel" pattern="[^' ']+" autocomplete="new-userName" />
              <div *ngIf="!userName1.valid && userName1.touched" class="error-message">
                Username Required
              </div>
              <div *ngIf="isUserName" class="error-message">
                Username already in use,
                <div class="pt-2"> Please use different Username</div>
              </div>
            </div>

            <div class="login-credentials-width">
              <label> Password <span>*</span> </label>
              <i *ngIf="newPasswordShowPasswordIcon" class="fa fa-eye eye-icon" aria-hidden="true" (click)="toggleNewPassword()"></i>
              <i *ngIf="!newPasswordShowPasswordIcon" class="fa fa-eye-slash eye-icon" aria-hidden="true" (click)="toggleNewPassword()"></i>
              <input [ngClass]="{
                                'border-invalid': !password1.valid && password1.touched,
                                'border-valid': password1.valid
                              }"
                     [type]="newPasswordShowPasswordIcon ? 'text':'password'"
                     class="form-control"
                     id="password"
                     name="password"
                     [(ngModel)]="password"
                     required
                     minlength="8"
                     maxlength="30"
                     #password1="ngModel"
                     (keyup)="checkpassword(password)"
                     (keyup)="passwordValidation(true)"
                     pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,30}$"
                     autocomplete="new-password" />
              <div *ngIf="!password1.valid && password1.touched" class="error-message">
                Password Required
              </div>
              <ng-container *ngIf="password">
                <p [ngClass]="{
                    'text-danger': !blnHasCapital,
                    'text-success': blnHasCapital
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasCapital,
                      'fa-times-circle': !blnHasCapital
                    }" aria-hidden="true"></i>
                  At least 1 upper case character
                </p>
                <p [ngClass]="{
                    'text-danger': !blnLowerCase,
                    'text-success': blnLowerCase
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnLowerCase,
                      'fa-times-circle': !blnLowerCase
                    }" aria-hidden="true"></i>
                  At least 1 lower case character
                </p>
                <p [ngClass]="{
                    'text-danger': !blnHasOneNumber,
                    'text-success': blnHasOneNumber
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasOneNumber,
                      ' fa-times-circle': !blnHasOneNumber
                    }" aria-hidden="true"></i>
                  At least 1 numeric digit
                </p>
                <p [ngClass]="{
                    'text-danger': !blnHasSpecialChar,
                    'text-success': blnHasSpecialChar
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasSpecialChar,
                      ' fa-times-circle': !blnHasSpecialChar
                    }" aria-hidden="true"></i>
                  1 non alphanumeric character between [!@#$%^&*]
                </p>
                <p [ngClass]="{
                    'text-danger': !blnHasLength,
                    'text-success': blnHasLength
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasLength,
                      'fa-times-circle': !blnHasLength
                    }" aria-hidden="true"></i>
                    Password must be between 8 to 30 characters.
                </p>
              </ng-container>
            </div>
            <div class="login-credentials-width">
              <label> Confirm Password <span>*</span> </label>
              <i *ngIf="confirmPasswordShowPasswordIcon" class="fa fa-eye eye-icon" aria-hidden="true" (click)="toggleConfirmPassword()"></i>
              <i *ngIf="!confirmPasswordShowPasswordIcon" class="fa fa-eye-slash eye-icon" aria-hidden="true" (click)="toggleConfirmPassword()"></i>
              <input [ngClass]="{
                                'border-invalid': !password2.valid && password2.touched,
                                'border-valid': password2.valid
                              }"
                     [type]="confirmPasswordShowPasswordIcon ? 'text':'password'"
                     class="form-control"
                     id="confirmPassword"
                     name="confirmPassword"
                     minlength="8"
                     maxlength="30"
                     [(ngModel)]="confirmPassword"
                     required
                     #password2="ngModel"
                     (keyup)="confirmPasswords(false)" />
              <div *ngIf="!password2.valid && password2.touched" class="error-message">
                Confirm Password Required
              </div>
              <div *ngIf="password !== confirmPassword" class="error-message">
                Password is not matching
              </div>
            </div>
          </div>
        </div>
        <div class="row bottom-action-wrapper pb-md-3">
          <div class="col-md-6 col-sm-6 next-btn-wrapper text-left padding-0">
            <button type="button" (click)="backToLogin()" class="btn btn-style btn-prev">
              &lt; Back to Login </button>
          </div>
          <div class="col-md-6 col-sm-6 next-btn-wrapper padding-0">
            <button type="submit" class="btn btn-style btn-next" [disabled]="
                !registrationForm.form.valid ||
                password !== confirmPassword ||
                isUserName
              ">
              Next >
            </button>
            <!-- <button type="submit" class="btn btn-style btn-next">
              Next >
            </button> -->
          </div>
        </div>
      </form>

      <!-- Registration 2nd Screen -->
      <form #providers="ngForm" (ngSubmit)="addDefaultFacilities(facilities)" *ngIf="providers">
        <div class="reg3-container">
          <div class="row">
            <div class="col-md-12 padding-0">
              <h3 class="sub-title"> Associated Prescriber(s)</h3>
              <p class="note">
                Please provide the following information for all prescribers you would like associated with your account.
              </p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-12 padding-0">
              <p class="required-text">
                <span>*</span>
                Required field
              </p>
            </div>
            <div class="col-md-5 custom-input-group pr-0 padding-0">
              <label class="mt-0"> Prescriber NPI # <span>*</span> </label>
              <input [ngClass]="{
                        'border-invalid': !hcpNpi1.valid && hcpNpi1.touched,
                        'border-valid': hcpNpi1.valid
                      }" type="text" class="form-control" required id="hcpNPI" name="hcpNPI" [(ngModel)]="hcpNPI"
                maxlength="10" minlength="10" #hcpNpi1="ngModel" appNumberonly />
              <div *ngIf="hcpNPI == '' && hcpNpi1.touched" class="error-message">
                Prescriber NPI is required
              </div>
      
              <div *ngIf="!hcpNpi1.valid && hcpNpi1.touched && hcpNPI != ''" class="error-message">
                Invalid Prescriber NPI
              </div>
            </div>
      
            <div class="col-md-3 custom-input-group pr-0 padding-0">
              <label class="mt-0">Prescriber First Name <span>*</span></label>
              <input [ngClass]="{
                        'border-invalid': !hcpName.valid && hcpName.touched,
                        'border-valid': hcpName.valid
                      }" type="text" class="form-control" required id="hcpFirstName" name="hcpFirstName"
                [(ngModel)]="hcpFirstName" maxlength="50" #hcpName="ngModel" (blur)="trimIt($event)" />
              <div *ngIf="!hcpName.valid && hcpName.touched" class="error-message">
                Prescriber first name is required
              </div>
            </div>
      
            <div class="col-md-3 custom-input-group padding-0">
              <label class="mt-0"> Prescriber Last Name <span>*</span> </label>
              <input [ngClass]="{
                        'border-invalid': !hcplastName.valid && hcplastName.touched,
                        'border-valid': hcplastName.valid
                      }" type="text" class="form-control" required id="hcpLastName" name="hcpLastName"
                [(ngModel)]="hcpLastName" #hcplastName="ngModel" maxlength="50" (blur)="trimIt($event)" />
              <div *ngIf="!hcplastName.valid && hcplastName.touched" class="error-message">
                Prescriber last name is required
              </div>
            </div>
      
            <div class="col-md-1 mt-auto custom-input-group provider-action-wrapper pl-md-0 padding-0">
              <button class="btn btn-style btn-next hcp-add-btn-height" type="button" (click)="
                        addProvidersReq(
                          hcpNPI,
                          hcpFirstName,
                          hcpLastName,
                          providers
                        )" [disabled]="!providers.form.valid">
                Add
              </button>
            </div>
            <div class="col-md-12 padding-0" *ngIf="isIncorrectNPI">
              <p class="error-text">
                One or more pieces of information entered do not match our
                records. Please try again or contact us for additional
                assistance.
              </p>
            </div>
          </div>
          <!-- <div class="row mb-3" *ngIf="(allProvidersMasterList | keyvalue)?.length">
                  <div class="col-md-12 padding-0">
                    <h3 class="sub-title">Associated Practice Office(s)</h3>
                    <p class="sub-note">
                      Please verify the practice offices that you and the healthcare
                      provider(s) are both associated with.
                    </p>
                  </div>
                </div> -->
      
          <!-- New Onboarding Flow -->
          <div class="table-pad" *ngIf="addedPrescriberList?.length">
            <div class="table-border">
      
              <p-table #prescriberTable class="case-panel-table" [value]="addedPrescriberList" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5,10,15]"
                selectionMode="single" [scrollable]="true" [responsive]="false">
                <ng-template pTemplate="header">
                  <tr style="border-bottom: 2px solid #ccc; border-top: 1px solid #ccc">
                    <th style="border:none; width: 10%;"></th>
                    <th style="border:none;">
                      <span class="d-flex align-items-center"> Prescriber NPI #
                      </span>
                    </th>
                    <th style="border:none;">
                      <span class="d-flex align-items-center"> Name
                      </span>
                    </th>
                    <th style="border:none;">
                      <span class="d-flex align-items-center"> Actions
                      </span>
                    </th>
      
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-pro>
                  <tr style="border-bottom: 1px solid #ccc">
                    <td style="border:none; width: 10%;"></td>
                    <td style="border:none;">{{pro.NPI}}</td>
                    <td style="border:none;">{{pro.PrescriberFirstName}} {{pro.PrescriberLastName}}</td>
                    <td style="border:none; text-align: initial;"><button type="button"
                        class="btn delete-btn ipad-pt-edit-del" (click)="deleteRow(pro)">
                        Delete
                      </button></td>
      
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      
        <div class="row reg3-container bottom-action-wrapper">
          <div class="col-md-6 col-sm-6 next-back-btn-wrapper text-left padding-left-0">
            <button class="btn btn-style btn-prev" (click)="prev1()" type="button">
              < Back </button>
          </div>
          <div
            class="col-md-6 col-sm-6 next-back-btn-wrapper padding-left-0 margin-0 nxt-btn-wrapper-mobile nxt-btn-del-wrapper">
            <button type="" class="btn btn-style btn-next" [disabled]="!addedPrescriberList.length" >
              Next >
            </button>
          </div>
        </div>
      
        <!-- <div class="row btn-section bottom-action-wrapper">
                <div class="col-md-6 col-sm-6 next-btn-wrapper text-left padding-0">
                  <button class="btn btn-prev btn-style" (click)="prev2()" type="button">
                    < Back </button>
                </div>
                <div class="col-md-6 col-sm-6 next-btn-wrapper pr-md-0 padding-0 margin-0">
                  <button type="button" class="btn btn-style btn-next pl-3 pr-3" (click)="registrationDone()"
                    [disabled]="!(allProvidersMasterList | keyvalue)?.length">
                    <img src="../../../../assets/images/submit-icon.png" class="submit-icon" />
                    Save & Register
                  </button>
                </div>
              </div> -->
      </form>
      
      <app-popup *ngIf="provIdDelete" popupHeader="Confirmation" popupText="Are you sure you want to delete?" [isImg]="false"
        (closePopup)="closeConFirmationPopUP($event)" noOfButtons="2">
      </app-popup>
      </div>

      <!-- Registration Last screen-->
      <form #facilities="ngForm" (ngSubmit)="addProviderData(providers)" *ngIf="additionalAddress">
        <div class="reg2-container">
          <div class="mob-container">

            <div class="row">
              <div class="col-md-12 padding-0">
                <h3 class="sub-title">Associated Practice Office(s)</h3>
                <p class="note">
                  Please select all practice/facility locations to be associated with each prescriber from the lists below. 
                  If you do not see the desired practice/facility location(s) for your prescriber(s) in the lists below, 
                  please proceed to the bottom of this screen.
                </p>

                <div class="row" *ngIf="newProvidersWithFacilities">
                  <div class="col-md-12 padding-0" *ngFor=" let item of newProvidersWithFacilities;
                          let i = index
                        ">
                    <p-accordion class="claims-accordion mt-3 accordion-custom-style provider-accordion-wrapper"
                      [multiple]="true">
                      <p-accordionTab [selected]="i === 0?true: false">
                        <p-header>
                          <span class="name-box">
                            Prescriber Name - 
                            <span class="prescriber-name">
                              {{
                                item.PrescriberFirstName + " " + item.PrescriberLastName
                              }}
      
                            </span>
                          </span>

                          <span class="mt-1 positionSpan" style="text-align: right">
                            <input type="text" name="search-facilities" id="search-facilities" class="search-facilities" [(ngModel)]="item.prescriberId"
                            (keyup)="facilityTable.filterGlobal(item.prescriberId, 'contains') " pInputText
                            size="20" placeholder="Search">
                            <button class="btn btn-search" >Done</button>
                          </span>
                        </p-header>
      
                        <p-table #facilityTable [value]="newProvidersWithFacilities[i].Facilities" [(selection)]="addressforScreen" dataKey="Name"
                          responsiveLayout="scroll" class="provider-accordion-data" [globalFilterFields]="['Name','Address1','Address2','City','State','Zip','Phone','Fax','Email']">
                          <ng-template pTemplate="header">
                            <tr class="sticky-table-header">
                              <th></th>
                              <th>Practice Name</th>
                              <th>Address</th>
                              <th>Phone</th>
                              <th>Fax</th>
                              <th class="text-left">Email</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-provi let-j="rowIndex">
                            <tr >
                              <td>
                                <input type="checkbox" name="checkbox" [checked]="provi.isSelected"
                                  (click)="getRowData($event,i,j, provi,newProvidersWithFacilities[i]?.NPI)" />
                              </td>
                              <td>{{ provi.Name || provi.GroupName }}</td>
                              <td>{{ addressFormatter(provi) }}</td>
                              <td>{{ provi.Phone }}</td>
                              <td>{{ provi.Fax }}</td>
                              <td class="text-left">{{ provi.Email }}</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                </div>

                <div class="mt-4 mb-4 partition"> 
                  <hr/>
                </div>
                <p class="note">
                  Please complete the required fields below to add a practice or facility location to your account.
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 padding-0">
                <p class="required-text">
                  <span>*</span>
                  Required field
                </p>
              </div>

              <div class="col-md-3 custom-input-group padding-0">
                <label class="contact-last-name-style mt-0">
                  Practice Name <span>*</span>
                </label>
                <input [ngClass]="{
                  'border-invalid': !contact.valid && contact.touched,
                  'border-valid': contact.valid
                }" type="text" class="form-control" id="practiceName" name="practiceName" [(ngModel)]="practiceName"
                  required #contact="ngModel" maxlength="50" (blur)="trimIt($event)" />
                <div *ngIf="!contact.valid && contact.touched" class="error-message">
                  Practice Name Required
                </div>
              </div>

              <div class="col-md-3 custom-input-group padding-0">
                <label class="mt-0"> Phone <span>*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !phone1.valid && phone1.touched,
                  'border-valid': phone1.valid
                }" type="text" class="form-control" name="associatePhone" appNumberformat [(ngModel)]="associatePhone"
                  [data]="providerFacilityPhone.value" required #phone1="ngModel" #providerFacilityPhone maxlength="14"
                  minlength="14" (change)="handleInputNumber($event)" />

                <div *ngIf="associatePhone == '' && phone1.touched" class="error-message">
                  Phone Required
                </div>

                <div *ngIf="!phone1.valid && phone1.touched && associatePhone != ''" class="error-message">
                  Invalid Phone Number
                </div>
              </div>

              <div class="col-md-3 custom-input-group padding-0">
                <label class="mt-0"> Fax <span>*</span></label>
                <input [ngClass]="{
                  'border-invalid': !fax1.valid && fax1.touched,
                  'border-valid': fax1.valid
                }" type="text" class="form-control" name="associateFax" appNumberformat [(ngModel)]="associateFax"
                  [data]="providerFacilityFax.value" #fax1="ngModel" #providerFacilityFax maxlength="14" minlength="14"
                  (change)="handleInputNumber($event)" required />
                <div *ngIf="associateFax == '' && fax1.touched" class="error-message">
                  Fax Required
                </div>
                <div *ngIf="!fax1.valid && fax1.touched && associateFax != ''" class="error-message">
                  Invalid Fax
                </div>
              </div>

              <div class="col-md-3 custom-input-group padding-0">
                <label class="mt-0"> Email <span>*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !email1.valid && email1.touched,
                  'border-valid': email1.valid
                }" type="text" class="form-control" name="associateEmail" [(ngModel)]="associateEmail" required
                  #email1="ngModel" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$" />
                <div *ngIf="associateEmail == '' && email1.touched" class="error-message">
                  Email Required
                </div>
                <div *ngIf="!email1.valid && email1.touched && associateEmail != ''" class="error-message">
                  Invalid Email
                </div>
              </div>

              <div class="col-md-3 custom-input-group padding-0">
                <label> Address 1 <span>*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !addressLine1.valid && addressLine1.touched,
                  'border-valid': addressLine1.valid
                }" type="text" class="form-control" id="address1" name="address1" [(ngModel)]="address1"
                  #addressLine1="ngModel" required />
                <div *ngIf="!addressLine1.valid && addressLine1.touched" class="error-message">
                  Address1 Required
                </div>
              </div>

              <div class="col-md-3 custom-input-group padding-0">
                <label> Address 2</label>
                <input type="text" class="form-control" id="address2" name="address2" [(ngModel)]="address2" />
              </div>

              <div class="custom-field custom-input-group pl-3 padding-left-0">
                <label> City <span>*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !city.valid && city.touched,
                  'border-valid': city.valid
                }" type="text" class="form-control" id="cityReg" name="cityReg" [(ngModel)]="cityReg" required
                  maxlength="35" #city="ngModel" />
                <div *ngIf="!city.valid && city.touched" class="error-message">
                  City Required
                </div>
              </div>
              <div class="custom-field custom-input-group custom-select-box">
                <label> State <span>*</span> </label>
                <ng-select [ngClass]="{
                  'border-invalid':
                    (!state.valid && state.touched) ||
                    (state.value == '--Select--' && state.touched),
                  'border-valid': state.valid
                }" class="form-control custom-dropdown ng-dropdown-panel-items ng-option-selected m-drop-down-display" id="stateReg"
                  name="stateReg" [(ngModel)]="stateReg" #state="ngModel" [clearable]="false" required>
                  <ng-option selected="selected" disabled>--Select--</ng-option>
                  <ng-option *ngFor="let state of staticStateList" value="{{ state.abbreviation }}">
                    {{ state.name }}&nbsp;
                  </ng-option>
                </ng-select>
                <div *ngIf="
                  (!state.valid && state.touched) ||
                  (state.value == '--Select--' && state.touched)
                " class="error-message">
                  State Required
                </div>
              </div>
              <div class="custom-field custom-input-group">
                <label> Zip <span>*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !zip2.valid && zip2.touched,
                  'border-valid': zip2.valid
                }" type="text" class="form-control" id="zipReg" name="zipReg" [(ngModel)]="zipReg" minlength="5"
                  maxlength="5" required #zip2="ngModel" appNumberonly />
                <div *ngIf="zipReg == '' && zip2.touched" class="error-message">
                  Zip Required
                </div>
                <div *ngIf="!zip2.valid && zip2.touched && zipReg != ''" class="error-message">
                  Invalid Zip
                </div>
              </div>

              <div class="button-group associate-action-wrapper custom-input-group ml-2">
                <button *ngIf="onAddEditRecordId" type="button" class="btn btn-style btn-prev add-update-btn mr-3"
                  (click)="cancelAddressUpdate(); facilities.form.reset()">
                  Cancel
                </button>
                <button *ngIf="onAddEditRecordId" type="button" class="btn btn-style btn-next add-update-btn"
                  (click)="editAddressUpdate(); facilities.form.reset()" [disabled]="
                  !facilities.form.valid || state.value == '--Select--'
                ">
                  Update
                </button>

                <button *ngIf="!onAddEditRecordId" type="button" class="btn btn-style add-btn w-100 add-new-btn"
                  (click)="
                  addAddress(
                    practiceName,
                    associatePhone,
                    associateFax,
                    associateEmail,
                    address1,
                    address2,
                    cityReg,
                    stateReg,
                    zipReg
                  );
                  facilities.form.reset();
                " [disabled]="
                  !facilities.form.valid || state.value == '--Select--'
                ">
                  Add
                </button>
              </div>
            </div>
          </div>
         <!-- table to show data -->
          <div [ngClass]="{
            'row my-1': true,
            'my-5': addressFromSecondScreen.length > 0
          }">
            <div class="table-container" *ngIf="addressFromSecondScreen.length > 0">
              <div class="table-bg practice-location-table">
                <table class="table table-striped table-custom-border">
                  <thead>
                    <tr class=" table-thread-header sticky-table-header bg-white">
                      <th scope="col">Practice Name</th>
                      <th scope="col">Address</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Fax</th>
                      <th scope="col">Email</th>
                      <th class="th-action">Edit / Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let add of addressFromSecondScreen" [ngClass]="{ 'disable-row': add.IsEditRow }">
                      <td>{{ add.PracticeName }}</td>
                      <td>{{ addressFormatter(add) }}</td>
                      <td>{{ add.Phone }}</td>
                      <td>{{ add.Fax }}</td>
                      <td>{{ add.Email }}</td>
                      <td class="td-action">
                        <button type="button" class="btn delete-btn" (click)="onEditAddressClick(add)"
                          [disabled]="add.IsEditRow">
                          Edit
                        </button>

                        <button type="button" class="btn delete-btn" (click)="deleteAddress(add)"
                          [disabled]="add.IsEditRow">
                          Delete
                        </button>

                        <button type="button" (click)="onEditAddressClick(add)" class="mob-view">
                          <img *ngIf="!add.IsEditRow" src="../../../../assets/images/editIcon.png" class="icon" />
                          <img *ngIf="add.IsEditRow" class="confirm" src="/assets/images/editIcon-disabled.png" />
                        </button>
                        <button type="button" (click)="deleteAddress(add)" class="mob-view">
                          <img *ngIf="!add.IsEditRow" src="../../../../assets/images/delete-icon.png" class="icon" />
                          <img *ngIf="add.IsEditRow" class="confirm confirm-delete" src="/assets/images/delete-icon-disabled.png" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row btn-section bottom-action-wrapper">
            <div class="col-md-6 col-sm-6 next-btn-wrapper text-left padding-0">
              <button class="btn btn-prev btn-style" (click)="prev2()" type="button">
                < Back </button>
            </div>
            <div class="col-md-6 col-sm-6 next-btn-wrapper pr-md-0 padding-0 margin-0">
              <button type="button" class="btn btn-style btn-next pl-3 pr-3" (click)="registrationDone()"
                [disabled]="!(checkedFacilityCount)?.length">
                <img src="../../../../assets/images/submit-icon.png" class="submit-icon" />
                Save & Register
              </button>
            </div>
          </div>

          <!-- <div class="row bottom-action-wrapper">
            <div class="col-md-6 col-sm-6 next-back-btn-wrapper text-left padding-left-0">
              <button class="btn btn-style btn-prev" (click)="prev1()" type="button">
                < Back </button>
            </div>
            <div class="col-md-6 col-sm-6 next-back-btn-wrapper padding-left-0 margin-0 nxt-btn-wrapper-mobile nxt-btn-del-wrapper">
              <button type="submit" class="btn btn-style btn-next" [disabled]="isFacilityEditingEnable">
                Next >
              </button>
            </div>
          </div> -->
        </div>
      </form>

    <!-- Registration Provider Wrapper -->
    <div *ngIf="userSelected == 'Provider'">
      <!-- New Provider Registration page-1  -->
      <form #registrationForm="ngForm" (ngSubmit)="onSubmitProviderPage1(registrationForm)" *ngIf="regNew">
        <div class="reg1-container">
          <div class="row bp-2">
            <div class="col-md-7 padding-0">
              <h3 class="sub-title">Step 1: Lookup Information</h3>

              <div class="row">
                <div class="col pl-0">
                  <p class="note">
                    Please look up your information from our provider registry
                    to associate with this new account.
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col pl-0">
                  <p class="required-text">
                    <span>*</span>
                    Required field
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col pl-0  padding-right-0">
                  <label for="providerNpi" class="mt-0">
                    Prescriber NPI <span class="required">*</span>
                  </label>
                  <input type="text" class="form-control" id="providerNpi" name="providerNpi" [(ngModel)]="providerNpi"
                    #providerNpi1="ngModel" maxlength="10" minlength="10" [disabled]="providerDisable" appNumberonly
                    autocomplete="off" />
                </div>
              </div>
              <div class="row loockup-info-row">
                <div class="input-col">
                  <label> First Name <span class="required">*</span> </label>
                  <input type="text" class="form-control" id="providerFirstName" name="providerFirstName"
                    [(ngModel)]="providerFirstName" #providerFirstName1="ngModel" maxlength="35"
                    [disabled]="providerDisable" autocomplete="off" />
                </div>

                <div class="input-col custom-padding">
                  <label> Last Name <span class="required">*</span> </label>
                  <input type="text" class="form-control" id="providerLastName" name="providerLastName"
                    [(ngModel)]="providerLastName" #providerLastName1="ngModel" maxlength="35"
                    [disabled]="providerDisable" autocomplete="off" />
                </div>

                <div class="addNpi padding-right-0">
                  <button class="btn btn-style btn-prev" [disabled]="
                      !(providerNpi && providerNpi1.valid) ||
                      !providerFirstName ||
                      !providerLastName ||
                      providerDisable
                    " *ngIf="isFindButton" (click)="addProviderNPIData($event)" type="button">
                    Find
                  </button>

                  <button class="btn btn-style btn-prev" *ngIf="!isFindButton" (click)="resetProviderDetails()"
                    type="button">
                    Reset
                  </button>

                </div>
              </div>
              <div class="row mt-2 error-message-div" *ngIf="providerNpiError">

                <div class="col-md-12 pl-0">
                  One or more pieces of information entered do not match our
                  records. Please try again or contact us for additional
                  assistance.
                </div>
              </div>
            </div>
            <div class="col-md-5 acc-info-container padding-0">
              <h3 class="sub-title-provider padding-0">
                Step 2: Complete Account Information
              </h3>

              <div class="acc-info-wrapper">
                <!-- <div class="row">
                  <div class="col  padding-0">
                    <p class="note">
                      Please confirm and update your information for this new account.
                    </p>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-md-6 col-6 padding-left-0">
                    <label class="contact-last-name-style">
                      First Name <span class="required">*</span>
                    </label>
                    <input [ngClass]="{
                        'border-invalid': !contact.valid && contact.touched,
                        'border-valid': contact.valid
                      }" type="text" class="form-control" id="firstName" name="firstName" [(ngModel)]="firstName"
                      required #contact="ngModel" maxlength="50" (blur)="validateField($event)" />

                    <div *ngIf="firstName == '' && isFirstNameError" class="error-message">
                      First Name Required
                    </div>
                    <div *ngIf="
                        !contact.valid && isFirstNameError && firstName != ''
                      " class="error-message">
                      Invalid First Name
                    </div>
                  </div>
                  <div class="col-md-6 6 col-6 padding-right-0">
                    <label> Last Name <span class="required">*</span> </label>
                    <input [ngClass]="{
                        'border-invalid': !lastName1.valid && lastName1.touched,
                        'border-valid': lastName1.valid
                      }" type="text" class="form-control" id="lastName" name="lastName" [(ngModel)]="lastName" required
                      #lastName1="ngModel" maxlength="50" (blur)="validateField($event)" />
                    <div *ngIf="lastName == '' && isLastNameError" class="error-message">
                      Last Name Required
                    </div>
                    <div *ngIf="
                        !lastName1.valid && isLastNameError && lastName != ''
                      " class="error-message">
                      Invalid Last Name
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-6 padding-left-0">
                    <label> Phone <span class="required">*</span> </label>
                    <input [ngClass]="{
                        'border-invalid': !phone1.valid && phone1.touched,
                        'border-valid': phone1.valid
                      }" type="text" class="form-control" id="phone" name="phone" appNumberformat [(ngModel)]="phone"
                      [data]="hcpPhone.value" required #phone1="ngModel" #hcpPhone maxlength="14" minlength="14"
                      (blur)="validateField($event)" />
                    <div *ngIf="phone == '' && isPhoneError" class="error-message">
                      Phone Number Required
                    </div>
                    <div *ngIf="!phone1.valid && isPhoneError && phone != ''" class="error-message">
                      Invalid Phone Number
                    </div>
                  </div>
                  <div class="col-md-6 col-6 padding-right-0">
                    <label> Fax <span class="required">*</span> </label>
                    <input [ngClass]="{
                        'border-invalid': !fax1.valid && fax1.touched,
                        'border-valid': fax1.valid
                      }" type="text" class="form-control" id="fax" name="fax" appNumberformat [(ngModel)]="fax"
                      [data]="fax2.value" required #fax1="ngModel" #fax2 maxlength="14" minlength="14"
                      (blur)="validateField($event)" />
                    <div *ngIf="fax == '' && isFaxError" class="error-message">
                      Fax Required
                    </div>
                    <div *ngIf="!fax1.valid && isFaxError && fax != ''" class="error-message">
                      Invalid Fax
                    </div>
                  </div>
                </div>
                <div class="col-md-12 padding-0">
                  <label> Email <span class="required">*</span> </label>
                  <input [ngClass]="{
                      'border-invalid': !email1.valid && email1.touched,
                      'border-valid': email1.valid
                    }" type="text" class="form-control" id="email" name="email" [(ngModel)]="email" required
                    #email1="ngModel" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$"
                    (blur)="validateField($event)" />
                  <div *ngIf="email == '' && isEmailError" class="error-message">
                    Email Required
                  </div>
                  <div *ngIf="!email1.valid && isEmailError && email != ''" class="error-message">
                    Invalid Email
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row user-detail-block user-create-username-password ">
            <div class="col-md-12 padding-0">
              <h3 class="sub-title">Step 3: Create Username and Password</h3>
            </div>
            <div class="col-md-12 pb-3 padding-0">
              <p class="note">
                Create a username and password to access your new online account.
              </p>
            </div>

            <div class="col-md-2 create-login">Create Login</div>

            <div class="username-width">
              <label> Username <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !userName1.valid && userName1.touched,
                  'border-valid': userName1.valid
                }" type="text" class="form-control" id="userName" name="userName" [(ngModel)]="userName" required
                #userName1="ngModel" pattern="[^' ']+" autocomplete="new-userName" />
              <div *ngIf="!userName1.valid && userName1.touched" class="error-message">
                Username Required
              </div>
              <div *ngIf="isUserName" class="error-message">
                Username already in use,
                <div class="pt-2">Please use different Username</div>
              </div>
            </div>
            <div class="login-credentials-width">
              <label> Password <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !password1.valid && password1.touched,
                  'border-valid': password1.valid
                }" type="password" class="form-control" id="password" name="password" [(ngModel)]="password" required
                minlength="8" maxlength="14" #password1="ngModel" (keyup)="checkpassword(password)" (keyup)="passwordValidation(true)"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,30}$" autocomplete="new-password" />
              <div *ngIf="!password1.valid && password1.touched" class="error-message">
                Password Required
              </div>
              <ng-container *ngIf="password">
                <p [ngClass]="{
                    'text-danger': !blnHasCapital,
                    'text-success': blnHasCapital
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasCapital,
                      'fa-times-circle': !blnHasCapital
                    }" aria-hidden="true"></i>
                  At least 1 upper case character
                </p>
                <p [ngClass]="{
                    'text-danger': !blnLowerCase,
                    'text-success': blnLowerCase
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnLowerCase,
                      'fa-times-circle': !blnLowerCase
                    }" aria-hidden="true"></i>
                  At least 1 lower case character
                </p>
                <p [ngClass]="{
                    'text-danger': !blnHasOneNumber,
                    'text-success': blnHasOneNumber
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasOneNumber,
                      ' fa-times-circle': !blnHasOneNumber
                    }" aria-hidden="true"></i>
                  At least 1 numeric digit
                </p>
                <p [ngClass]="{
                    'text-danger': !blnHasSpecialChar,
                    'text-success': blnHasSpecialChar
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasSpecialChar,
                      ' fa-times-circle': !blnHasSpecialChar
                    }" aria-hidden="true"></i>
                  1 non alphanumeric character between [!@#$%^&*]
                </p>
                <p [ngClass]="{
                    'text-danger': !blnHasLength,
                    'text-success': blnHasLength
                  }">
                  <i class="fa" [ngClass]="{
                      'fa-check-circle-o': blnHasLength,
                      'fa-times-circle': !blnHasLength
                    }" aria-hidden="true"></i>
                    Password must be between 8 to 14 characters
                </p>
              </ng-container>
            </div>


            <div class="login-credentials-width">
              <label> Confirm Password <span>*</span> </label>
              <input [ngClass]="{
                  'border-invalid': !password2.valid && password2.touched,
                  'border-valid': password2.valid
                }" type="password" class="form-control" id="confirmPassword" name="confirmPassword" minlength="8" maxlength="14"
                [(ngModel)]="confirmPassword" required #password2="ngModel" (keyup)="confirmPasswords(false)" />
              <div *ngIf="!password2.valid && password2.touched" class="error-message">
                Confirm Password Required
              </div>
              <div *ngIf="password !== confirmPassword" class="error-message">
                Password is not matching
              </div>
            </div>
          </div>

        </div>

        <div class="row bottom-action-wrapper pb-md-3">
          <div class="col-md-6  col-sm-6 next-btn-wrapper text-left padding-0">
            <button type="button" (click)="prev0()" class="btn btn-style btn-prev">
              < Back </button>
          </div>
          <div class="col-md-6 col-sm-6 next-btn-wrapper padding-0">
            <button type="submit" class="btn btn-style btn-next" [disabled]="
            !registrationForm.form.valid ||
            this.password !== this.confirmPassword ||
            this.isUserName
          ">
              Next >
            </button>
            <!-- <button type="submit" class="btn btn-style btn-next">
              Next >
            </button> -->
          </div>
        </div>
      </form>
      <!-- New Address Page-2 -->
      <form #facilities="ngForm" (ngSubmit)="addDefaultFacilitiesOnProvider(facilities)" *ngIf="additionalAddress">
        <div class="reg2-container">
          <div class="mob-container">

            <div class="row">
              <div class="col-md-12 padding-0">
                <h3 class="sub-title">Practice Office(s)</h3>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12 padding-0">
                <p class="note">
                  Please add or update the Practice/Facility information
                  associated with this new account.
                </p>
              </div>
            </div> -->

            <div class="row">
              <div class="col padding-0">
                <p class="required-text">
                  <span>*</span>
                  Required field
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 padding-0 custom-input-group">
                <label class="mt-0"> Practice Name <span class="required">*</span> </label>
                <input [ngClass]="{
                  'border-invalid':
                    !addPracticeName1.valid && addPracticeName1.touched,
                  'border-valid': addPracticeName1.valid
                }" type="text" class="form-control" id="addPracticeName" name="addPracticeName"
                  [(ngModel)]="addPracticeName" #addPracticeName1="ngModel" maxlength="50" (blur)="trimIt($event)"
                  required />
                <div *ngIf="addPracticeName == '' && addPracticeName1.touched" class="error-message">
                  Practice Name Required
                </div>

              </div>
              <div class="col-md-3 padding-0 custom-input-group">
                <label class="mt-0"> Phone <span>*</span></label>
                <input [ngClass]="{
                  'border-invalid': !addPhone1.valid && addPhone1.touched,
                  'border-valid': addPhone1.valid
                }" type="text" class="form-control" id="addPhone" name="addPhone" appNumberformat
                  [(ngModel)]="addPhone" #addPhone1="ngModel" #addPhone2 minlength="14" maxlength="14"
                  [data]="addPhone2.value" (change)="handleInputNumber($event)" required />
                <div *ngIf="addPhone == '' && addPhone1.touched" class="error-message">
                  Phone Number Required
                </div>
                <div *ngIf="!addPhone1.valid && addPhone1.touched && addPhone != ''" class="error-message">
                  Invalid Phone Number
                </div>
              </div>
              <div class="col-md-3 custom-input-group padding-0">
                <label class="mt-0"> Fax <span>*</span></label>
                <input [ngClass]="{
                  'border-invalid': !addFax1.valid && addFax1.touched,
                  'border-valid': addFax1.valid
                }" type="text" class="form-control" id="addFax" name="addFax" [(ngModel)]="addFax" minlength="14"
                  maxlength="14" #addFax1="ngModel" #addFax2 appNumberformat [data]="addFax2.value"
                  (change)="handleInputNumber($event)" required />
                <div *ngIf="addFax == '' && addFax1.touched" class="error-message">
                  Fax Required
                </div>
                <div *ngIf="!addFax1.valid && addFax1.touched && addFax != ''" class="error-message">
                  Invalid Fax
                </div>
              </div>
              <div class="col-md-3 custom-input-group padding-0">
                <label class="mt-0"> Email <span>*</span></label>
                <input [ngClass]="{
                  'border-invalid': !addEmail1.valid && addEmail1.touched,
                  'border-valid': addEmail1.valid
                }" type="text" class="form-control" id="addEmail" name="addEmail" [(ngModel)]="addEmail"
                  #addEmail1="ngModel" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" required />
                <div *ngIf="addEmail == '' && addEmail1.touched" class="error-message">
                  Email Required
                </div>
                <div *ngIf="!addEmail1.valid && addEmail1.touched && addEmail != ''" class="error-message">
                  Invalid Email
                </div>
              </div>
            </div>

            <div class="row align-items-start">
              <div class="col-md-3 padding-0 custom-input-group">
                <label> Address 1 <span class="required">*</span> </label>
                <input [ngClass]="{
                  'border-invalid':
                    !provAddress01.valid && provAddress01.touched,
                  'border-valid': provAddress01.valid
                }" type="text" class="form-control" id="provAddress1" name="provAddress1" [(ngModel)]="provAddress1"
                  #provAddress01="ngModel" required />
                <div *ngIf="provAddress1 == '' && provAddress01.touched" class="error-message error-message-stick">
                  Address1 Required
                </div>
                <div *ngIf="
                  !provAddress01.valid &&
                  provAddress01.touched &&
                  provAddress1 != ''
                " class="error-message">
                  Invalid Address1
                </div>
              </div>

              <div class="col-md-3 padding-0 custom-input-group">
                <label> Address 2 </label>
                <input type="text" class="form-control" id="provAddress2" name="provAddress2"
                  [(ngModel)]="provAddress2" />
              </div>
              <div class="custom-field custom-input-group pl-3 padding-left-0">
                <label> City <span class="required">*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !provCity1.valid && provCity1.touched,
                  'border-valid': provCity1.valid
                }" type="text" class="form-control" id="provCity" name="provCity" [(ngModel)]="provCity" required
                  maxlength="35" #provCity1="ngModel" />
                <div *ngIf="provCity == '' && provCity1.touched" class="error-message">
                  City Required
                </div>
                <div *ngIf="!provCity1.valid && provCity1.touched && provCity != ''" class="error-message">
                  Invalid City
                </div>
              </div>
              <div class="custom-field custom-select-box custom-input-group">
                <label> State <span class="required">*</span> </label>
                <ng-select [ngClass]="{
                  'border-invalid':
                    (!provState1.valid && provState1.touched) ||
                    (provState1.value == '--Select--' && provState1.touched),
                  'border-valid': provState1.valid
                }" class="form-control custom-dropdown" id="provState" name="provState" [(ngModel)]="provState"
                  #provState1="ngModel" [clearable]="false" required>
                  <ng-option selected="selected" disabled>--Select--</ng-option>
                  <ng-option *ngFor="let state of staticStateList" value="{{ state.abbreviation }}">
                    {{ state.name }}&nbsp;
                  </ng-option>
                </ng-select>

                <div *ngIf="
                  (!provState1.valid && provState1.touched) ||
                  (provState1.value == '--Select--' && provState1.touched)
                " class="error-message">
                  State Required
                </div>
              </div>
              <div class="custom-field custom-input-group">
                <label> Zip <span class="required">*</span> </label>
                <input [ngClass]="{
                  'border-invalid': !provZip1.valid && provZip1.touched,
                  'border-valid': provZip1.valid
                }" type="text" class="form-control" id="provZip" name="provZip" [(ngModel)]="provZip" minlength="5"
                  maxlength="5" required #provZip1="ngModel" appNumberonly />
                <div *ngIf="provZip == '' && provZip1.touched" class="error-message">
                  Zip Required
                </div>
                <div *ngIf="!provZip1.valid && provZip1.touched && provZip != ''" class="error-message">
                  Invalid Zip
                </div>
              </div>

              <div class="button-group associate-action-wrapper custom-input-group ml-2">
                <button *ngIf="onAddEditRecordId" type="button" class="btn btn-style btn-prev add-update-btn mr-3"
                  (click)="
                  cancelAddressUpdateOnProvider(); facilities.form.reset()
                ">
                  Cancel
                </button>

                <button *ngIf="onAddEditRecordId" type="button" class="btn btn-style btn-next add-update-btn"
                  (click)="editAddressUpdateOnProvider(); facilities.form.reset()" [disabled]="
                  !facilities.form.valid || provState1.value == '--Select--'
                ">
                  Update
                </button>

                <button *ngIf="!onAddEditRecordId" type="button"
                  class="btn btn-style btn-prev add-update-btn w-100 add-new-btn"
                  (click)="addAddressOnProvider(); facilities.form.reset()" [disabled]="
                  !facilities.form.valid || provState1.value == '--Select--'
                ">
                  Add
                </button>
              </div>
            </div>
          </div>


          <div [ngClass]="{
            'mt-5': addressFromSecondScreen.length,
            'row': true
            }">
            <div class="col-md-12 padding-0">
              <div class="mb-5 attach-table table-bg practice-location-table" *ngIf="addressFromSecondScreen.length">
                <table class="table table-striped table-insurance table-custom-border">
                  <thead class="sticky-table-header">
                    <tr style="color: #40488D; border-bottom: 0.25rem solid #ECEDEE">
                      <th scope="col">Practice Name</th>
                      <th scope="col">Address</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Fax</th>
                      <th scope="col">Email</th>
                      <th>
                        <span>Edit / Delete</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let add of addressFromSecondScreen" class="table-row"
                      [ngClass]="{ 'disable-row': add.isEdit }">
                      <td>{{ add.PracticeName }}</td>
                      <td>{{ addressFormatter(add) }}</td>
                      <td>{{ add.Phone }}</td>
                      <td>{{ add.Fax }}</td>
                      <td>
                        <span>{{ add.Email }}</span>
                      </td>
                      <td class="td-action">
                        <button type="button" class="btn btn-prev delete-btn mr-2" [disabled]="add.isEdit"
                          (click)="editAddressOnProvider(add)">
                          <span>Edit</span>
                        </button>

                        <button type="button" class="btn btn-prev delete-btn" [disabled]="add.isEdit"
                          (click)="deleteAddressOnProvider(add)">
                          Delete
                        </button>

                        <button type="button" (click)="editAddressOnProvider(add)" class="mob-view" [disabled]="add.isEdit">
                          <img *ngIf="!add.isEdit" src="../../../../assets/images/editIcon.png" class="icon" /> 
                          <img *ngIf="add.isEdit" class="confirm" src="../../../../assets/images/editIcon-disabled.png" />
                        </button>
                        <button type="button" (click)="deleteAddressOnProvider(add)" class="mob-view" [disabled]="add.isEdit">
                          <img *ngIf="!add.isEdit" src="../../../../assets/images/delete-icon.png" class="icon" />
                          <img *ngIf="add.isEdit" class="confirm confirm-delete" src="../../../../assets/images/delete-icon-disabled.png" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row bottom-action-wrapper">
            <div class="col-md-6 col-sm-6 padding-0 next-btn-wrapper text-left">
              <button class="btn btn-style btn-prev" (click)="prev1()" type="button">
                < Back </button>
            </div>
            <div class="col-md-6 col-sm-6 padding-0 next-btn-wrapper" style="text-align: right">
              <button type="submit" class="btn btn-style btn-next pl-3 pr-3"
                [disabled]="(!addressFromSecondScreen.length > 0) || (isFacilityEditingEnable)">
                <img src="../../../../assets/images/submit-icon.png" class="submit-icon" />
                Save & Register
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="confirm-message" *ngIf="conMessage">
      <span>Thank You for Registering!</span>
      <div class="confirm-message-text">
        <div class="confirm-message-text-container text-center">
          <p>
            Your registration request has been submitted. A confirmation email has been sent to the email address entered during the registration process.
          </p>
          <p>
            You will receive another email notification within 1 business day regarding your account approval.
          </p>
          <p>
            We will verify your account by calling the phone number listed for each of your associated practice offices.
          </p>
          <p>
            If you have any questions, please contact us at 1-888-256-9929.
          </p>
        </div>
      </div>
      <div class="btn-container">
        <button class="btn btn-style btnBackToLogin" (click)="backToLogin()" type="button">
          Back to Login
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="download-btn" (click)="downloadFile()">
      <img src="../../../../assets/images/download-icon.svg" class="download-icon" />
      Download
    </button>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss('Cross click')">
      Close
    </button>
  </div>
  <div class="modal-body">
    <div style="height: 80vh;">
      <ng2-pdfjs-viewer pagemode="none" [pdfSrc]="contentURL" [download]="false" [openFile]="false"
        [page]="page"></ng2-pdfjs-viewer>
    </div>
  </div>

</ng-template>